var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('GsaNavigator',{attrs:{"gsa_list":_vm.all_gsa}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }